<template>
  <div v-if="showLoading" class="custom_loading_wrap" ref="custom_loading">
    <div class="custom_loading_div">
      <img class="custom_loading_img" src="@/assets/icon/loading.gif" />
    </div>
  </div>
</template>

<script>
  let app = null

	export default {
		name: "CustomLoading",
    data () {
		  return {
        show: false,
        showLoading: false
      }
    },
    watch: {
      show: function (val) {
        if (val) {
          this.showLoading = true
          setTimeout(function() {
            app.$refs['custom_loading'].classList.add('on')
          }, 100)
        }
        else {
          this.$refs['custom_loading'].classList.remove('on')
          setTimeout(function() {
            app.showLoading = false
          }, 100)
        }
      }
    },
    created () {
      app = this
    }
	}
</script>

<style scoped>
  .custom_loading_wrap { position: fixed; height: 100%; z-index: 2000; background-color: hsla(0,0%,0%,.8); margin: 0; top: 0; right: 0; bottom: 0; left: 0; transition: opacity .2s; opacity: 0; box-sizing: initial;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
  .custom_loading_wrap.on { opacity: 1; }
  .custom_loading_div { top: 50%; margin-top: -35px; width: 100%; text-align: center; position: absolute; }
  .custom_loading_img { height: 70px; width: 70px; }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue